<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item label="作用范围">
                    <el-select v-model="scopeSelected" placeholder="请选择" clearable @change="scopeChange">
                        <!--<el-option label="公司" value="company" :disabled="scopeDisabled"></el-option>-->
                        <el-option label="工厂" value="factory"></el-option>
                        <el-option label="车间" value="shop"></el-option>
                        <el-option label="工段" value="vsm"></el-option>
                        <el-option label="产线" value="line"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工厂">
                    <el-select v-model="fcIdSelected" placeholder="请选择" :clearable="isclear" :disabled="ischeck" filterable
                               @change="fcChange">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.value"
                            :label="factory.label"
                            :value="factory.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择" clearable filterable @change="shopChange"
                               :disabled="scopeSelected =='factory'||scopeSelected=='company'">
                        <el-option
                            v-for="shop in shopList"
                            :key="shop.value"
                            :label="shop.label"
                            :value="shop.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="sectionSelected" placeholder="请选择" clearable filterable @change="sectionChange"
                               :disabled="scopeSelected =='shop'|| scopeSelected =='factory'||scopeSelected=='company'">
                        <el-option
                            v-for="section in sectionList"
                            :key="section.value"
                            :label="section.label"
                            :value="section.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="lineSelected" placeholder="请选择" clearable filterable @change="lineChange"
                               :disabled="scopeSelected =='shop'|| scopeSelected =='factory'||scopeSelected=='company'||scopeSelected=='vsm'">
                        <el-option
                            v-for="line in lineList"
                            :key="line.value"
                            :label="line.label"
                            :value="line.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安灯类型">
                    <el-select v-model="atId" placeholder="请选择" clearable filterable @change="aTChange">
                        <el-option
                            v-for="atype in andonTypelist"
                            :key="atype.atId"
                            :label="atype.atName"
                            :value="atype.atId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安灯种类">
                    <el-select v-model="acCode" placeholder="请选择" clearable filterable @change="aCChange">
                        <el-option
                            v-for="acontent in andonContentList"
                            :key="acontent.acId"
                            :label="acontent.acName"
                            :value="acontent.acCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安灯级别">
                    <el-select v-model="andonLeveLSelected" placeholder="请选择" clearable>
                        <el-option
                            v-for="level in andonLevelList"
                            :key="level.value"
                            :label="level.label"
                            :value="level.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchTable">查询</el-button>
                    <el-button type="primary" @click="addAndonRule" v-for="acc in access" v-if="acc=='RU0001'">新增
                    </el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="规则列表" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                <el-button size="small" type="success" @click="exportAndonRule">导出</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="atName" label="安灯类型" show-overflow-tooltip/>
                <el-table-column prop="acName" label="安灯种类" show-overflow-tooltip/>
                <el-table-column prop="arLevel" sortable label="安灯级别" show-overflow-tooltip/>
                <el-table-column prop="arTrigger" label="触发条件" show-overflow-tooltip/>
                <el-table-column prop="arCode" label="触发条件编号" width="110px" show-overflow-tooltip/>
                <!--                <el-table-column prop="createUser" label="创建用户" show-overflow-tooltip />-->
                <el-table-column prop="arScope" label="作用范围" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <!--<span v-if="scope.row.arScope == 'company'">公司级</span>-->
                        <span v-if="scope.row.arScope == 'factory'">工厂级</span>
                        <span v-if="scope.row.arScope == 'shop'">车间级</span>
                        <span v-if="scope.row.arScope == 'vsm'">工段级</span>
                        <span v-if="scope.row.arScope == 'line'">产线级</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sfName" label="所属工厂" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.fcName}}//{{scope.row.shopName}}//{{scope.row.sectionName}}//{{scope.row.lineName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="arResponseSpan" label="响应时效" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.hasOwnProperty('arResponseSpan')">{{scope.row.arResponseSpan/60}}分钟</span>
                    </template>
                </el-table-column>
                <el-table-column prop="arSolveSpan" label="处理时效" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.hasOwnProperty('arSolveSpan')">{{scope.row.arSolveSpan/60}}分钟</span>
                    </template>
                </el-table-column>
                <el-table-column prop="arArriveSpan" label="到达现场时效" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.hasOwnProperty('arArriveSpan')">{{scope.row.arArriveSpan/60}}分钟</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <!--<i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false),updatehOpen(scope.row)" />
                        <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" />-->
                        <i class="editBtn iconfont u-youjianbianji" @click="ruleEditor(scope.row)" v-for="acc in access"
                           v-if="acc=='RU0002'"/>
                        <!-- <i class="delBtn iconfont u-shanchu" @click="deleteRule(scope.row)" /> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
    </div>
</template>

<script>
    import { deteleAndonRule, exportAndonRule } from '../../../libs/api'

    export default {
        name: 'andonRuleList',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                andonTypelist: [],
                andonContentList: [],
                aTypeSelected: '',
                aCSelected: '',
                atId: '',
                acCode: '',
                andonLeveLSelected: '',
                scopeSelected: '',
                scopeDisabled: true,
                ischeck: true,
                //安灯级别
                andonLevelList: [
                    {
                        value: 1,
                        label: '一级'
                    },
                    {
                        value: 2,
                        label: '二级'
                    },
                    {
                        value: 3,
                        label: '三级'
                    }
                ],
                factoryTree: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                userInfo: {},
                role: {},
                access: [],
                isclear: false,
                fcCode: ''
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            aTList: function() {
                var arr = []
                if (this.andonTypelist != undefined && this.andonTypelist.length > 0) {
                    for (var i = 0; i < this.andonTypelist.length; i++) {
                        arr.push({
                            label: this.andonTypelist[i].typeName,
                            id: this.andonTypelist[i].id,
                            value: this.andonTypelist[i],
                            parent: 0
                        })
                    }
                }
                return arr
            },
            aCList: function() {
                var arr = []
                if (this.aTypeSelected != undefined && this.aTypeSelected.length > 0) {
                    var aContent = JSON.parse(this.aTypeSelected)
                    var content = aContent.contentList
                    if (content != undefined) {
                        for (var i = 0; i < content.length; i++) {
                            arr.push({
                                label: content[i].content,
                                id: content[i].id,
                                value: JSON.stringify(content[i]),
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            this.init()
        },
        activated() {
            this.init()
        },
        methods: {
            init() {
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getData()
                this.getAndonType()
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            fcChange: function() {
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                this.acCode = ''
                this.andonContentList = []
                this.searchTable()
                this.getAndonContent()
            },
            shopChange: function() {
                this.sectionSelected = ''
                this.lineSelected = ''
                this.searchTable()
            },
            sectionChange: function() {
                this.lineSelected = ''
                this.searchTable()
            },
            lineChange: function() {
                this.searchTable()
            },
            ruleEditor(rule) {
                if (rule.arId != undefined && rule.arId != '') {
                    let query = {
                        ruleId: rule.arId,
                    }
                    if (rule.fcCode != undefined && rule.fcCode != '') {
                        query['fcCode'] = rule.fcCode
                    }
                    this.$router.push({
                        path: '/editRule',
                        query: query
                    })
                } else {
                    this.$message.error('此数据暂时无法编辑')
                }
            },
            deleteRule(row) {
                console.log('row.arId', row.arId)
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'GET',
                                url: this.$api.deteleAndonRule + row.arId
                            })
                            .then(response => {
                                this.searchTable()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.searchTable()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            addAndonRule() {
                this.$router.push({
                    path: '/editRule',
                    query: {
                        ruleId: 0
                    }
                })
                // this.$router.push({path:'/addAndonRule'})
            },
            async exportAndonRule() {
                let queryParams = {}
                var self = this
                if (self.aTypeSelected != undefined && self.aTypeSelected != '') {
                    queryParams['atId'] = JSON.parse(self.aTypeSelected).id
                }
                if (self.aCSelected != undefined && self.aCSelected != '') {
                    queryParams['acCode'] = JSON.parse(self.aCSelected).acCode
                }
                if (self.andonLeveLSelected != '') {
                    queryParams['arLevel'] = self.andonLeveLSelected
                }
                if (self.scopeSelected != undefined && self.scopeSelected != '') {
                    queryParams['arScope'] = self.scopeSelected
                }
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportAndonRule,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '安灯规则信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                var self = this
                if (self.atId != undefined && self.atId != '') {
                    queryParams['atId'] = self.atId
                }
                if (self.acCode != undefined && self.acCode != '') {
                    queryParams['acCode'] = self.acCode
                }
                if (self.andonLeveLSelected != '') {
                    queryParams['arLevel'] = self.andonLeveLSelected
                }
                if (self.scopeSelected != undefined && self.scopeSelected != '') {
                    queryParams['arScope'] = self.scopeSelected
                }
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getAllAndonRule
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            aTChange() {
                this.acCode = ''
                this.searchTable()
                this.getAndonContent()
            },
            aCChange() {
                this.searchTable()
            },
            scopeChange() {
                this.fcIdSelected = ''
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
            },
            getAndonType() {
                let options = {
                    method: 'GET',
                    url: this.$api.getAllAndonType,
                }
                this.$http.request(options).then(response => {
                    this.andonTypelist = response.data
                })
            },
            getAndonContent() {
                let params = {}
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                } else {
                    return
                }
                if (this.atId != undefined && this.atId != '') {
                    params['atId'] = this.atId
                }
                let options = {
                    method: 'GET',
                    url: this.$api.andonContentList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    this.andonContentList = response.data
                })
            },
            getData() {
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        if (this.factoryTree[i].deptID == this.role.factoryId) {
                            this.fcIdSelected = JSON.stringify(this.factoryTree[i])
                        }
                    }
                    this.searchTable()
                })
            }
        }
    }
</script>

<style scoped>

</style>
